import { useRef, useState, useCallback, useEffect } from 'react';
import { useFormikContext } from "formik";

import { RECAPTCHA } from '../main_config';
import { useStyles } from './useStyles';

export const useRecaptcha = (setChangeToken) => {
  const classes = useStyles(() => ({
    containerRecaptcha: { 
      display: 'none',
    },
  }));
  const recaptchaRef = useRef(null);
  const domObservr = useRef(null);
  const { setSubmitting } = useFormikContext();

  const [prevVisibleChallengesCount, setPrevVisibleChallengesCount] = useState(0);

  const [loaded, setLoaded] = useState(false);
  const [token, setToken] = useState('');
  const [expiredToken, setExpiredToken] = useState(false);
  const [executing, setExecuting] = useState(false);

  const handleChange = useCallback(
    (tokenValue) => {
      setToken(tokenValue);
      setExpiredToken(false);
      setExecuting(false);
      setChangeToken(tokenValue);
    },
    [setChangeToken],
  );

  const handleExpired = () => setExpiredToken(true);
  
  const asyncScriptOnLoad = () => setLoaded(!loaded);
  
  const executeRecaptcha = () => {
    setExecuting(true);
    recaptchaRef.current.execute();
  }

  const resetRecaptcha = () => {
    recaptchaRef.current.reset();
    setExpiredToken(false);
  }

  // funcion para detectar cuando se haga click afuera del modal del desafio del recaptcha
  const handleDomChange = useCallback(
    () => {
      const iframes = document.querySelectorAll('iframe[title="Desafío de reCAPTCHA"]');
      const containers = [...iframes].map(iframe => iframe.parentNode.parentNode);
      const visibleContainersCount = containers.filter(el => el.style.visibility === 'visible').length;
  
      if ((visibleContainersCount < prevVisibleChallengesCount) && executing) {
        // Esto cambia el LoadingIndicator a false
        setSubmitting(false);
        setExecuting(false);
      }
  
      setPrevVisibleChallengesCount(visibleContainersCount);
    },
    [prevVisibleChallengesCount, executing, setSubmitting]
  );

  useEffect(() => {
    domObservr.current = new MutationObserver(handleDomChange);

    domObservr.current.observe(document.body, { childList: true });

    return () => {
      domObservr.current.disconnect();
    };
  }, [handleDomChange]);

  const PropsComponent = {
    theme: "dark",
    size: "invisible",
    ref: recaptchaRef,
    sitekey: RECAPTCHA.PUBLICKEY,
    onChange: handleChange,
    onExpired: handleExpired,
    className: classes.containerRecaptcha,
    grecaptcha: window.grecaptcha,
    asyncScriptOnLoad,
  }
  
  return {
    loaded,
    executing,
    token,
    expiredToken,
    executeRecaptcha,
    resetRecaptcha,
    ReCaptchaProps: PropsComponent
  };
}